import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Only scroll to top on PUSH/REPLACE navigation, never on POP (back/forward)
    const isBackNavigation = navigationType === 'POP';
    
    if (!isBackNavigation) {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return null;
};
